import React from "react";
import { observer } from "mobx-react";
import { CurrencyUpdateStore } from "../../store";
import { CurrencyUpdateForm } from "./CurrencyUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type CurrencyUpdateProps = {
  currencyUpdateStore: CurrencyUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const CurrencyUpdate: React.FC<CurrencyUpdateProps> = observer(
  ({ currencyUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={currencyUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={currencyUpdateStore.savedButOutdated}
          onReload={() => currencyUpdateStore.reloadCurrency()}
          reloadDisabled={currencyUpdateStore.isProcessing}
        />
        <CurrencyUpdateForm
          currencyUpdateStore={currencyUpdateStore}
          codeError={currencyUpdateStore.errors.code?.message}
          onCodeChange={(value: string) => {
            currencyUpdateStore.setCodeValue(value);
          }}
          code={currencyUpdateStore.entityValues.code}
          nameError={currencyUpdateStore.errors.name?.message}
          onNameChange={(value: string) => {
            currencyUpdateStore.setNameValue(value);
          }}
          name={currencyUpdateStore.entityValues.name}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={currencyUpdateStore.saveDisabled}
          onSave={() => currencyUpdateStore.saveCurrency()}
          onCancel={() => currencyUpdateStore.cancelCurrency()}
        />
        <ErrorDialog
          open={currencyUpdateStore.errorDialogOpened}
          title={currencyUpdateStore.errorTitle}
          description={currencyUpdateStore.errorDescription}
          onClose={() => currencyUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={currencyUpdateStore.confirmDialogOpened}
          title={currencyUpdateStore.confirmDialogTitle}
          description={currencyUpdateStore.confirmDialogDescription}
          onConfirm={() => currencyUpdateStore.executeConfirmedAction()}
          onCancel={() => currencyUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
